import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";

// Polyfill for process object in browser environment
if (typeof window !== 'undefined') {
  (window as any).process = { env: {} };
}

// Configured primary color
// Also support api in future for theming
ConfigProvider.config({
  theme: {
    primaryColor: "0065FF",
    successColor: "#52AE32",
    errorColor: "#E63312",
    warningColor: "#FFCD1C",
    infoColor: "#F07E26",
    processingColor: "#1D1D1B",
  },
});

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
